function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.587 1A.597.597 0 0 0 1 1.607v15.786c0 .335.263.607.587.607h16.826a.597.597 0 0 0 .587-.607.597.597 0 0 0-.587-.607H2.173V1.607A.597.597 0 0 0 1.588 1zm11.74 3.44c-.355 0-.632.34-.618.64.016.317.31.591.617.575h1.657l-5.203 5.06-1.871-1.613a.588.588 0 0 0-.49-.215.583.583 0 0 0-.354.158l-3.913 3.643c-.24.208-.27.63-.061.872.21.242.617.256.844.032l3.54-3.295 1.883 1.625c.207.249.62.27.85.045l5.662-5.503v1.822c-.005.32.276.613.587.613.31 0 .59-.293.586-.613V5.048c0-.318-.28-.607-.586-.608h-3.13z",
  fillRule: "nonzero",
  stroke: "#858585",
  strokeWidth: 0.3
});

var SvgStats = function SvgStats(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 19",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Stats.e19815f5.svg";
export { ForwardRef as ReactComponent };